import { createFileRoute } from "@tanstack/react-router";
import FractionalCmoPricingArticle, {
  PRICING_DESCRIPTION,
  PRICING_PATH,
  PRICING_SCHEMA,
  PRICING_TITLE,
} from "@/pages/FractionalCmoPricingArticle";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/fractional-cmo-definition-missions-tarifs")({
  head: () => {
    const base = pageHead({ path: PRICING_PATH, title: PRICING_TITLE, description: PRICING_DESCRIPTION, enPath: null });
    return {
      ...base,
      meta: [
        ...(base.meta ?? []),
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      scripts: PRICING_SCHEMA.map((s) => ({ type: "application/ld+json", children: JSON.stringify(s) })),
    };
  },
  component: FractionalCmoPricingArticle,
});
